module.exports = __webpack_public_path__ + "static/media/excavation-4.b32176f8.jpg";